import { Tag } from "antd";

const statusToColor = {
  Approved: "cyan",
  Pending: "default",
  Rejected: "orange",
};

const LeaveStatus = ({ status }) => (
  <Tag
    color={statusToColor[status]}
    style={{
      borderRadius: "20px",
      fontWeight: "bold",
    }}
  >
    {status}
  </ Tag>
);
export default LeaveStatus;
